import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ComponentTitleService {
  private title = new Subject<string>();
  title$ = this.title.asObservable();

  constructor() {

   }

  setTitle(title: string) {
    this.title.next(title);
   }
  }
